import React, { useState, useEffect } from 'react';
import Panel from 'Components/Panel/Panel'
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import ApplyAttributes from 'Components/ApplyAttributes/ApplyAttributes';
import OptionsDataByAttributePath from 'Components/Options/optionsData/OptionsDataByAttributePath';
import AutomaticallyListedAttributes from 'Components/AutomaticallyListedAttributes/AutomaticallyListedAttributes';
import NewOperationProduct from '../NewOperationProduct/NewOperationProduct';
import ResetVariables from 'Components/ResetVariables/ResetVariables';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';
import NewOperationSupplier from '../newOperationSupplier/NewOperationSupplier';

const OperationsProductOperation = ({
    onUpdateProductOperationIdSelected,
    productOperationIdSelected,
    productIdSelected
}) => {
    const [showNewOperationProduct, setShowNewOperationProduct] = useState(false);
    const [showNewOperationSupplier, setShowNewOperationSupplier] = useState(false);

    const [idProductOperation, setIdProductOperation] = useState(null);
    const [dsOperation, setDsOperation] = useState(null);
    const [machineId, setMachineId] = useState(null);
    const [timePerOperation, setTimePerOperation] = useState(null);
    const [operationSequence, setOperationSequence] = useState(null);
    const [username, setUsername] = useState(null);
    const [dtUpdate, setDtUpdate] = useState(null);

    const [updating, setUpdating] = useState(false);
    const [loadingProductOperationPanel, setLoadingProductOperationPanel] = useState(null);
    const [recordsProductOperationByUserId, setRecordsProductOperationByUserId] = useState(null);
    const [attributesDetailProductOperationPanel, setAttributesDetailProductOperationPanel] = useState(null);
    const [machineList, setMachineList] = useState(null);
    const [isExternal, setIsExternal] = useState('N');
    const [updateOperationsProduct, setUpdateOperationsProduct] = useState(false);

    const readOnlyAttributes = !(showNewOperationProduct || updating);
    const itemsMachineOptions = OptionsDataByAttributePath(machineList, ['description'], null, true);

    const attributeList = [
        { name: "id", value: idProductOperation, setter: setIdProductOperation, allowsMultipleRecordsSelected: true },
        { name: "dsOperation", value: dsOperation, setter: setDsOperation, style: { height: '80px' }, minGridWidth: '400px', maxGridWidth: '400px', whiteSpace: 'normal', cursor: 'text' },
        { name: "machineId", value: machineId, setter: setMachineId, comboboxOptions: itemsMachineOptions },
        {
            name: "isExternal", value: isExternal, setter: setIsExternal, readOnlyGrid: !updating, columnType: 'checkbox',
            checks: [
                { field: 'isExternal', condition: 'VALUE_EQUALS', arrayValue: ['S'] }
            ]
        },
        { name: "timePerOperation", value: timePerOperation, setter: setTimePerOperation, minimumFractionDigits: 4 },
        { name: "operationSequence", value: operationSequence, setter: setOperationSequence },
        { name: "username", value: username, setter: setUsername },
        { name: "dtUpdate", value: dtUpdate, setter: setDtUpdate }
    ];

    useEffect(() => {
        reloadListProductOperation()
    }, []);

    useEffect(() => {
        reloadListProductOperation()
    }, [productIdSelected]);

    useEffect(() => {
        reloadListProductOperation()
        if ((!productOperationIdSelected || productOperationIdSelected.length != 1) && updating) {
            setUpdating(false)
        }
    }, [productOperationIdSelected, showNewOperationProduct, updating]);

    const reloadDetailValues = async () => {
        if (productOperationIdSelected && productOperationIdSelected.length === 1) {
            await fetchDataDetail(productOperationIdSelected[0]);
        } else {
            await fetchDataDetail(null);
        }
    };

    const reloadGridAndDetail = async () => {
        reloadDetailValues()
        reloadListProductOperation()
    };

    useEffect(() => {
        reloadDetailValues()
    }, [productOperationIdSelected]);

    useEffect(() => {
        const onReady = async () => {
            await callToSetMachineList();
        };

        onReady();
    }, []) // lista fixa: carrega uma vez ao abrir a tela

    async function callToSetMachineList() {
        const machineList = await ExecuteAxios.api('get', `/machine/get-active-machine-list/`)
        setMachineList(machineList)
    }

    const productOperationPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        width: '50%',
        borderRight: '2px solid rgb(204, 204, 204)'
    };

    async function getProductOperationRecords(productIdSelected) {
        const parameters = { productId: productIdSelected ? productIdSelected : 0 }
        const productOperations = await ExecuteAxios.api('get', `/product-operation/get-product-operation-grid/`, { params: parameters });
        setRecordsProductOperationByUserId(productOperations);
        RemoveIdsNotFound.remove(productOperations, onUpdateProductOperationIdSelected, productOperationIdSelected)
    }

    const fetchDataDetail = async (productOperationIdSelected) => {
        const parameters = { id: productOperationIdSelected ? productOperationIdSelected : 0 }
        const productOperation = await ExecuteAxios.api('get', `/product-operation/get-product-operation-detail/`, { params: parameters })
        if (productOperation) {
            setAttributesDetailProductOperationPanel(productOperation)
            ApplyAttributes.applyAttributes(productOperation, attributeList)
        }

        if (!productOperationIdSelected || productOperationIdSelected.length === 0) {
            ResetVariables.resetVariables(attributeList);
        }
    };

    function reloadListProductOperation() {
        if (productIdSelected && productIdSelected.length === 1) {
            getProductOperationRecords(productIdSelected[0])
        } else {
            getProductOperationRecords(null)
        }
    }

    const getProductOperationPanelListOrDetail = () => {
        if (!updating) {
            return (
                <PanelListDefault
                    onUpdateIdSelected={onUpdateProductOperationIdSelected}
                    idsSelected={productOperationIdSelected}
                    data={recordsProductOperationByUserId}
                    attributeList={attributeList}
                />
            )
        } else {
            return (
                <AutomaticallyListedAttributes
                    list={attributesDetailProductOperationPanel}
                    attributeList={attributeList}
                    readOnlyAttributes={readOnlyAttributes}
                />
            )
        }
    }

    async function deleteOperationsProductIdsSelecteds(recordsSelected) {
        try {
            setLoadingProductOperationPanel(true)
            const parameters = {
                idsList: recordsSelected.join(",")
            };
            const response = await ExecuteAxios.api('delete', `/product-operation/`, { params: parameters });
            if (response) {
                onUpdateProductOperationIdSelected([]);
            }
            return response
        } finally {
            setLoadingProductOperationPanel(false)
        }
    }

    async function putProductOperation() {
        try {
            setLoadingProductOperationPanel(true)
            const response = await ExecuteAxios.api('put', `/product-operation/`, {
                id: idProductOperation,
                dsOperation: dsOperation,
                machineId: machineId,
                timePerOperation: timePerOperation,
                operationSequence: operationSequence,
                isExternal: isExternal
            });

            if (response) {
                reloadListProductOperation()
            }

            return response;
        } finally {
            setLoadingProductOperationPanel(false)
        }
    }

    function callToShowNewOperationProduct(value) {
        setShowNewOperationProduct(value)
    }

    /*function getUploadButton() {
        return (
            <UploadButton
                clickMethod={() => { setDataUploadButton(true) }}
                buttonName={'Importar arquivo'}
                disabled={(productOperationIdSelected && productOperationIdSelected.length !== 1) || (productIdSelected && productIdSelected.length === 0)}
            />
        )
    }*/

    return (
        <>
            <NewOperationProduct
                onUpdateShowNewOperationProduct={setShowNewOperationProduct}
                onUpdateShowNewOperationSupplier={setShowNewOperationSupplier}
                onUpdateOperationsProduct={setUpdateOperationsProduct}
                showNewOperationProduct={showNewOperationProduct}
                showNewOperationSupplier={showNewOperationSupplier}
                productIdSelected={productIdSelected}
            />
            <NewOperationSupplier
                onUpdateShowNewOperationSupplier={setShowNewOperationSupplier}
                showNewOperationSupplier={showNewOperationSupplier}
                productIdSelected={productIdSelected}
            />

            <Panel
                style={productOperationPanelStyle}
                titlePage={'Operações produto'}
                setUpdating={setUpdating}
                setInserting={(value) => { callToShowNewOperationProduct(value) }}
                showNewOperationProduct={showNewOperationProduct}
                updating={updating}
                enableEdit={true}
                canDelete={true}
                deleteFunction={deleteOperationsProductIdsSelecteds}
                enableDelete={productOperationIdSelected && productOperationIdSelected.length > 0 && productIdSelected && productIdSelected.length === 1}
                canEdit={productOperationIdSelected && productOperationIdSelected.length === 1 && productIdSelected && productIdSelected.length === 1}
                putFunction={putProductOperation}
                enableNewRecord={true}
                canNewRecord={productIdSelected && productIdSelected.length === 1 && !showNewOperationProduct}
                canViewCRUD={true}
                readOnly={false}
                recordsSelected={productOperationIdSelected}
                resetVariables={() => { ResetVariables.resetVariables(attributeList) }}
                className={'main-modal two right'}
                //componentLeftButtons={getUploadButton()}
                dataListedAttributes={attributesDetailProductOperationPanel}
                attributeList={attributeList}
                onUpdateIdSelected={onUpdateProductOperationIdSelected}
                reloadFilter={() => {
                    reloadGridAndDetail()
                }}
            >
                <LoadingIndicator loaded={!loadingProductOperationPanel}>
                    {getProductOperationPanelListOrDetail()}
                </LoadingIndicator>

            </Panel>
        </>
    );

}
export default OperationsProductOperation;